import _ from 'lodash';

export const attributionHelper = {
  parsedAttributionCookie() {
    const cookie = window.Cookies.get('attribution_params');
    return cookie ? JSON.parse(cookie) : {};
  },

  getStoredSource(fallbackSource = undefined) {
    return _.get(this.parsedAttributionCookie(), 'source', fallbackSource);
  },
};
